import z from 'zod';
import {tradeWriteSchema} from '../trade/tradeWriteSchema';
import {tradeExtensionMessageRequestSchema} from './tradeExtensionMessageRequestSchema';
import {refineTradeExtensionCreateOpenClosed} from './tradeExtensionSchemaRefinements';

/**
 * Extension trade **create** wire shape — same field set as **`tradeWriteSchema`**, but **`messages`**
 * use the extension wire shape (`tradeExtensionMessageRequestSchema`). Creates an open trade or a **fully closed** trade in one write.
 *
 * Refinement: when **`status`** is **`open`**, exit fields must be unset/zero; when not **`open`**, **`exitPrice`** and **`closedAt`** must be positive.
 * See **`refineTradeExtensionCreateOpenClosed`** — not duplicated on **`tradeWriteSchema`** (no cross-field rules there).
 */
export const tradeExtensionCreateRequestSchema = tradeWriteSchema
  .omit({messages: true})
  .extend({
    messages: tradeExtensionMessageRequestSchema.array().default([]),
  })
  .superRefine(refineTradeExtensionCreateOpenClosed);

export interface TradeExtensionCreateRequest extends z.infer<typeof tradeExtensionCreateRequestSchema> {}
